import React from "react";
import BoxData from "../Box";
import CardNav from "../CardNav";
import { Col, Container, Row, Card } from "react-bootstrap";
import { images } from "../../../../constants";

const SingleAds = () => {
  return (
    <div>
      <Row>
        <CardNav Header="Single adds" />

        <Col lg="12">
          <Card className="shadow-main">
            <BoxData
              Title="Food & Resturent"
              Butonn="Create Shop"
              imgg={images.Foodbar}
              url="/restaurant-integrate"
              link="/restaurant-shop-form"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default SingleAds;
